import * as React from 'react';
import { SeatingChoiceProps } from '../../components/cart/seat-choice';

const SeatingChoiceView: React.StatelessComponent<SeatingChoiceProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLInputElement>) {
        const updatedValue = evt.currentTarget.value;
        props.updateSeatingChoice(parseInt(updatedValue));
    }

    return (

        props.originalSeats.length > 0 && props.originalSeats.length > props.currentNumberOfSeats ?
            <div>
                <div dangerouslySetInnerHTML={{ __html: props.seatSelectionDescription.replace("{0}", props.currentNumberOfSeats.toString()) }}></div>
                <div>{props.seatingChoice.length} of {props.currentNumberOfSeats} {props.currentNumberOfSeats > 1 ? "seats" : "seat" } selected</div>
                <ul>
                    {
                        props.originalSeats.map((seat) => {
                            const checked = props.seatingChoice.indexOf(seat.id) >= 0;
                            const allSeatsChosen = props.currentNumberOfSeats <= props.seatingChoice.length;
                            return (
                                <li>
                                    <input type="checkbox" checked={checked} onChange={(evt) => onChange(evt)} id={"seat-" + seat.id} value={seat.id} disabled={!checked && allSeatsChosen} />
                                    <label htmlFor={"seat-" + seat.id}>{seat.sectionDescription + " - " + seat.zoneDescription + " - Row " + seat.row + " - Seat " + seat.number}</label>
                                </li>
                                )
                        })
                    }
                </ul>
            </div> : null);
}

export default SeatingChoiceView